export default __webpack_public_path__ + "static/media/9.c87d5c6f.webp";